import { ref, computed, onMounted } from 'vue'
import { getArticleExtra, getCategoryIdList } from '@/api/article.js'

const useArticle = () => {
  const getIosChrome = () => {
    let ua = navigator.userAgent.toLowerCase()
    return ua.includes('iphone os 16') && ua.match(/crios\/([\d.]+)/)
  }
  const delayShow = ref(false)
  onMounted(() => {
    // 针对 Ios 16 Chrome position error
    if (getIosChrome()) setTimeout(() => (delayShow.value = true), 460)
    else delayShow.value = true
  })

  // 面包屑
  const breadcrumbs = computed(() => {
    return [
      {
        name: '主頁',
        path: '/'
      },
      {
        name: categoryInfo.value?.parent?.title,
        path: categoryInfo.value?.parent?.link
      },
      {
        name: categoryInfo.value?.title,
        path: categoryInfo.value?.link
      }
    ]
  })
  const categoryInfo = ref()
  const cloading = ref(true)
  const fetchCategoryInfo = async (id) => {
    try {
      const res = await getCategoryIdList({ category_id: id })
      if (res.code !== 0) throw new Error(res.message)
      categoryInfo.value = res?.data
      cloading.value = false
    } catch (error) {
      cloading.value = false
    }
  }

  const eloading = ref(true)
  const fetchExtraInfo = async (id, params = {}, callback) => {
    try {
      const res = await getArticleExtra({ article_id: id, ...params })
      if (res.code !== 0) throw new Error(res.message)
      // console.log('文章详情--Extra', res.data)
      callback && callback(res.data)
      eloading.value = false
    } catch (error) {
      console.warn(error)
      eloading.value = false
    }
  }

  return {
    delayShow,
    breadcrumbs,
    categoryInfo,
    cloading,
    fetchCategoryInfo,
    eloading,
    fetchExtraInfo
  }
}

export default useArticle
